import { render, staticRenderFns } from "./EditarConcurso.vue?vue&type=template&id=09fff0c8&scoped=true&"
import script from "./EditarConcurso.vue?vue&type=script&lang=js&"
export * from "./EditarConcurso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fff0c8",
  null
  
)

export default component.exports